export const getHeaders = () => ({});

export const getHeadersForCsv = () => ({
  headers: { Accept: "text/csv;charset=utf-8" },
});
